module.exports = __webpack_public_path__ + "static/media/right-arrow.00b8c38a.svg";